// Centralised route constants for the rental-distribution module.
// Backend route renames are a one-file change.
//
// Approval is RUN-LEVEL — there are deliberately no per-payout approve paths.
// A payout can be held, but that is what happens to a frozen investor, not an
// action an operator takes on one line.

const RENTAL_DISTRIBUTIONS = '/api/admin/rental-distributions'

// Run-level detail paths sit behind a static `runs/` segment. Without it the
// backend's `:id` route would also match the sibling sub-resources mounted
// under this prefix — rent-receipts, rent-ledger, investor-payouts — and their
// list calls would come back 400 "uuid is expected".
const RUNS = `${RENTAL_DISTRIBUTIONS}/runs`

export const RENTAL_DISTRIBUTIONS_ENDPOINT_PATHS = {
  LIST: RENTAL_DISTRIBUTIONS,
  STATUS_COUNTS: `${RENTAL_DISTRIBUTIONS}/status-counts`,
  PERIODS: `${RENTAL_DISTRIBUTIONS}/periods`,
  ELIGIBLE_PROPERTIES: `${RENTAL_DISTRIBUTIONS}/eligible-properties`,
  PREVIEW: `${RENTAL_DISTRIBUTIONS}/preview`,
  DECLARE: RENTAL_DISTRIBUTIONS,

  DETAIL: (distributionId: string) => `${RUNS}/${distributionId}`,
  PAYOUTS: (distributionId: string) => `${RUNS}/${distributionId}/payouts`,
  APPROVE: (distributionId: string) => `${RUNS}/${distributionId}/approve`,
  SUBMIT_FOR_APPROVAL: (distributionId: string) => `${RUNS}/${distributionId}/submit-for-approval`,
  APPROVAL_PERMISSION: (distributionId: string) => `${RUNS}/${distributionId}/approval-permission`,
  REJECT: (distributionId: string) => `${RUNS}/${distributionId}/reject`,
  REVERSE: (distributionId: string) => `${RUNS}/${distributionId}/reverse`,
  REVERSAL_PERMISSION: (distributionId: string) => `${RUNS}/${distributionId}/reversal-permission`,
  RETRY_FAILED: (distributionId: string) => `${RUNS}/${distributionId}/retry-failed`,
  PAYMENT_PERMISSION: (distributionId: string) => `${RUNS}/${distributionId}/payment-permission`,
  PROCESS_PAYOUTS: (distributionId: string) => `${RUNS}/${distributionId}/process-payouts`,
} as const
